/** @type {import("@mui/material").SxProps<Theme>} */

const styles = theme => ({
  Checkbox: {
    pl: '1.75rem',
    pr: '1.25rem',
    mt: '1rem',
    [theme.breakpoints.up('sm')]: {
      pl: '31.75rem',
      pr: '0.54rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '24.8rem',
      pr: '0.54rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      pl: '29.75rem',
      pr: '0.54rem',
    },
  },
  insuranceCardOnly: {
    pl: '1.75rem',
    pr: '1.75rem',
    mt: '1rem',
    [theme.breakpoints.up('sm')]: {
      pl: '13.35rem',
      pr: '13.54rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      p: '0 12.5rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      p: '0 14.95rem',
    },
    [theme.breakpoints.up('lg')]: {
      p: '0 16rem',
    },
  },
  InsuranceModalRoot: {
    '& .MuiBackdrop-root': {
      '@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none)': {
        background: theme.palette.primary.boxShadow,
        backdropFilter: 'blur(4.5px)',
      },
      '@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
        background: theme.palette.primary.boxShadow3Medium,
      },
    },
    '& .MuiBox-root': {
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
        padding: '0px 8px',
      },
    },
  },
  insuranceLink: {
    textDecoration: 'underline',
    color: theme.palette.primary.buttonColor,
  },
  mainContainerBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 3.75rem)',
    maxWidth: '956px',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 1rem)',
    },
  },
  mainHeadingBox: {
    background: theme.palette.primary.header,
    borderRadius: '10px 10px 0px 0px',
    height: '56px',
    boxShadow: `0px 2px 1px -1px ${theme.palette.primary.boxShadow4Lite}, 0px 1px 1px 0px  ${theme.palette.primary.boxShadow4Lite}, 0px 1px 3px 0px ${theme.palette.primary.arrows}`,
  },
  insuranceContainer: {
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      p: '1.5rem 0rem 0rem 0rem !important',
    },
  },
  insuranceContainerCards: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  mainHeading: {
    color: theme?.palette.primary.offerMain,
    letterSpacing: '0.25px',
    p: '12px 0px 12px 0px',
    margin: 'auto',
  },
  closeIcon: {
    color: theme?.palette.secondary.errorCTA,
    alignItems: 'right',
    marginRight: '18px',
    cursor: 'pointer',
  },
  accordMain: {
    borderRadius: '0px 0px 10px 10px',
    background: theme?.palette.secondary.contrastText,
    '&:not(:last-child)': {
      borderRadius: '0px',
    },
  },
  accordSummaryMain: {
    height: '55px',
    '& .MuiAccordionSummary-content': {
      margin: '17.95px 0px 14.05px 0px',
      paddingLeft: '8px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '17.95px 0px 0px 0px',
    },
  },
  accordSummaryTitle: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
});

export default styles;
